// extracted by mini-css-extract-plugin
export var brand = "_7f-8";
export var compact = "_7f-5";
export var extraSmall = "_7f-6";
export var icon = "_7f-0";
export var large = "_7f-3";
export var light = "_7f-1";
export var medium = "_7f-4";
export var outline = "_7f-a";
export var primaryDark = "_7f-9";
export var primaryLight = "_7f-7";
export var primaryModern = "_7f-b";
export var success = "_7f-2";